import track from './track';

/**
 * Handle the search tracking events
 * @param {ISiteSearchData} search - containing the search keys we want to track
 */
export default function siteSearch(search) {
    return track({
        ...{
            event: 'siteSearch', // konstant, wird als Trigger in GTM genutzt
            searchType: 'product-search', // Typ der Suche (produkt-search, kategorie-search, etc.)
            suggestSearch: 'false', // Wenn Suggest-Search verwendet wird, bitte auf true, sonst auf false setzen
            siteSearchPage: window.location.pathname, // Seite von der aus die Suche gestartet wurde
            siteSearchQuery: '', // nach was gesucht wurde. bei autosuggestion ist dies das angeklickte query aus der Liste
            siteSearchResultsTotalAmount: '0', // Gesamtanzahl von Suchtreffer
            siteSearchTypedQuery: '', // eingetippte Suchphrase
            siteSearchResults: {}, // Die im Array stehende Produktkategorien sollen dynamisch erweitert werden, einsprachig auf Deutsch
        },
        ...search,
    });
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/tracking/site-search.js